import { toastr } from 'react-redux-toastr';
import errorMessage from '../errorMessages/errorMessage_en';

const showToaster = async ({ messageId, toasterType, requestMessage, language, customMessage }) => {

    let message, lang, title;
    lang = language ? language : "en";

    // If customMessage is provided, use it directly (for content filter messages)
    if (customMessage) {
        title = toasterType === 'error' ? 'Error' : 'Info';
        message = customMessage;
    } else if (lang == "en") {
        title = await errorMessage(toasterType);
        message = await errorMessage(messageId, requestMessage)
    }
    return toastr[toasterType](title, message)
}
export default showToaster;
